const KEY = 'CONTENTS_SETTING'
export const GLOBAL_SETTING_KEY = "global"
export class ContentsSetting {
  constructor(namespace) {
    const item = localStorage.getItem(KEY) || '{}'
    this.namespace = namespace
    this.cache = JSON.parse(item)[namespace] || {}
  }

  fetchSetting() {
    return this.cache
  }

  getAll() {
    return Object.assign({}, this.cache)
  }

  getValue(key, defaultVal) {
    return this.cache[key] || defaultVal
  }

  overWriteAndSave(key, value) {
    this.cache[key] = value
    this.flush()
  }

  appendAndSave(key, value) {
    if (!this.cache[key]) {
      this.cache[key] = []
    }
    this.cache[key].push(value)
    this.flush()
  }

  flush() {
    const item = localStorage.getItem(KEY) || '{}'
    const latest = JSON.parse(item) || {}
    latest[this.namespace] = this.cache
    localStorage.setItem(KEY, JSON.stringify(latest))
  }

  clear() {
    this.cache = {}
    localStorage.removeItem(KEY)
  }
}



// WEBPACK FOOTER //
// ./src/components/common/ContentsSetting.js